import { combineReducers } from "redux";

import { InitializeReducer } from "./initialize/reducer";
import { GetStatusReducer } from "./getStatus/reducer";

export const EnairaReducer = combineReducers({
  initialize: InitializeReducer,
  getStatusReducer: GetStatusReducer,
});
